import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Container } from "./styles";
import { Form, Button, Spinner } from "react-bootstrap";

import { useDispatch } from "react-redux";
import { signInSuccess } from "../../../store/modules/auth/actions";

import axios from "axios";
import { useTranslation } from "react-i18next";

function Login() {
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({
      email: "",
      password: "",
    });
    setMsg("");

    let lock_errors = {
      email: "",
      password: "",
    };

    if (values.email.length < 4) {
      lock_errors.email = "Preencha esse campo";
    } else if (
      values.email.indexOf("@") === -1 ||
      values.email.indexOf(".") === -1
    ) {
      lock_errors.email = "E-mail inválido";
    }

    if (values.password.length < 6) {
      lock_errors.password = "Mínimo de 06 caracteres";
    }

    if (lock_errors.email !== "" || lock_errors.password !== "") {
      return setErrors(lock_errors);
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`/sessions`, {
        email: values.email,
        password: values.password,
      });
      axios.defaults.headers.Authorization = `${data.type} ${data.token}`;

      const { data: dataUser } = await axios.get(`/me`);
      dispatch(
        signInSuccess(
          data.token,
          {
            username: dataUser.username,
            email: dataUser.email,
            id: dataUser.id,
          },
          {
            companyId: dataUser.company.id,
            background: dataUser.company.background,
            primary: dataUser.company.colorPrimary,
            secondary: dataUser.company.colorSecundary,
            type: dataUser.company.type,
            logo: dataUser.company.logo,
          }
        )
      );
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setMsg("Este e-mail não está cadastrado");
      } else if (err.response && err.response.status === 401) {
        setMsg("E-mail ou senha incorretos");
      } else if (err.response && err.response.status === 500) {
        setMsg("Ocorreu um erro em nossos servidores, tente mais tarde.");
      } else {
        setMsg("Ocorreu um erro, tente novamente");
      }
    }
    setLoading(false);
  };

  return (
    <Container>
      <div className="d-flex justify-content-center align-items-center flex-column">
        <img src="/assets/logo.png" alt="Tupi - Plataforma de vídeo" className="logo" />
        <h4>{t("Painel Administrativo")}</h4>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <Form onSubmit={handleSubmit}>
          {msg !== "" && (
            <Form.Text className="text-white text-center mb-2">{msg}</Form.Text>
          )}
          <Form.Group>
            <Form.Label>E-mail</Form.Label>
            <Form.Control
              value={values.email}
              onChange={(e) =>
                setValues({
                  ...values,
                  email: e.target.value,
                })
              }
              type="email"
              placeholder={t("Digite seu e-mail")}
              disabled={loading}
              required
            />
            {errors.email !== "" && (
              <Form.Text className="text-white">{errors.email}</Form.Text>
            )}
          </Form.Group>
          <Form.Group>
            <Form.Label>{t("Senha")}</Form.Label>
            <Form.Control
              value={values.password}
              onChange={(e) =>
                setValues({
                  ...values,
                  password: e.target.value,
                })
              }
              type="password"
              placeholder={t("Digite sua senha")}
              disabled={loading}
              required
            />
            {errors.password !== "" && (
              <Form.Text className="text-white">{errors.password}</Form.Text>
            )}
          </Form.Group>
          <Button
            variant="success"
            className="btn-block mt-4"
            type="submit"
            disabled={loading}
          >
            {loading ? <Spinner animation="border" /> : t("Acessar")}
          </Button>
          {!loading && (
            <Link
              to="forgot-password"
              className="text-white text-center mt-4 d-block"
            >
              {t("Esqueceu sua senha?")}
            </Link>
          )}
        </Form>
      </div>
    </Container>
  );
}

export default Login;
